import { Tag } from "antd"
import { EditOutlined } from "@ant-design/icons"

export const renderImportStatusTag = (status) => {
  const getStatusConfig = (st) => {
    switch (st?.toLowerCase()) {
      case "failed":
        return { color: "#FEE", textColor: "#D32F2F", text: "Failed" }
      case "action_required":
        return { color: "#FFF3E0", textColor: "#F57C00", text: "Action required" }
      case "completed":
        return { color: "#E8F5E9", textColor: "#388E3C", text: "Completed" }
      default:
        return { color: "#F5F5F5", textColor: "#666", text: st || "-" }
    }
  }
  const config = getStatusConfig(status)
  return (
    <div className="flex-1 text-left">
      <Tag
        style={{
          backgroundColor: config.color,
          color: config.textColor,
          border: "none",
          borderRadius: "4px",
          padding: "2px 8px"
        }}
      >
        {config.text}
      </Tag>
    </div>
  )
}

export const getHeaders = ({ field, order, onEditClick }) => [
  {
    title: "# ",
    dataIndex: "row_number",
    key: "row_number",
    width: 60,
    sorter: true,
    sortOrder: field === "row_number" ? order : null
  },
  {
    title: "Client Name ",
    dataIndex: "client_name",
    key: "client_name",
    sorter: true,
    sortOrder: field === "client_name" ? order : null,
    render: (text) => text || "-"
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    sortOrder: field === "email" ? order : null,
    render: (text) => text || "-"
  },
  {
    title: "Phone Number",
    dataIndex: "phone_number",
    key: "phone_number",
    render: (text) => text || "-"
  },
  {
    title: "Import Status ",
    dataIndex: "import_status",
    key: "import_status",
    sorter: true,
    sortOrder: field === "import_status" ? order : null,
    render: (status) => renderImportStatusTag(status)
  },
  {
    title: "Error (if any)",
    dataIndex: "error_message",
    key: "error_message",
    render: (text) => text || "-"
  },
  {
    title: "Actions",
    dataIndex: "actions",
    key: "actions",
    width: 80,
    render: (_, record) => {
      return record?.current_status === "partial_completed" &&
        (record?.import_status === "failed" || record?.import_status === "action_required") ? (
        <EditOutlined
          style={{ fontSize: "16px", cursor: "pointer", color: "#1890ff" }}
          onClick={(e) => {
            e.stopPropagation()
            if (onEditClick) onEditClick(record)
          }}
        />
      ) : (
        "-"
      )
    }
  }
]
